import { useTokenStore, useUserStore } from '@/store';
import { getRequest, postRequest, putRequest } from '@/utils/request';
import { storage } from '@/plugins/ionic-storage';

// const { token, setData: setTokenData } = useTokenStore();

const keyMap: { [k: string]: string } = {
  name: 'nickname',
};

export const updateUser = (data: { [k: string]: any }) => {
  const userStore = useUserStore();
  Object.keys(data).forEach((key) => {
    if (keyMap[key]) {
      data[keyMap[key]] = data[key];
      delete data[key];
    }
  });
  data.userId = userStore.user.userId;
  data.nickname = data.nickname || userStore.user.nickname;
  return putRequest('/users/update', data).then((res) => {
    console.log(res, userStore);
    return res;
  });
};

export const getUserInfo = () => {
  const userStore = useUserStore();
  return getRequest('/users/get-current-user', {
    roleType: userStore.user.type,
  }).then((res) => {
    console.log('res=====', res);
    userStore.setUser({
      ...res.user,
      todayApplyCount: res.profile?.todayApplyCount,
      todayRemainCount: res.profile?.todayRemainCount,
      profile: res.profile ?? null,
    });
    return res;
  });
};

export const getBasicUserInfo = (data) => {
  return getRequest('/users/get-basic-info', data);
}

export const refreshToken = async () => {
  const { token, setData: setTokenData } = useTokenStore();
  return postRequest(
    '/users/refresh-token',
    {},
    {
      params: {
        refreshToken: token.refreshToken || (await storage.get('refreshToken')),
      },
    },
  ).then((res) => {
    setTokenData(res);
  });
};

export const setRole = (roleType: number) =>
  postRequest('/users/select-role', { roleType });

// 通告主已拉黑的博主列表 /advertiser/profiles/blocked-influencers get
export const getBlockedInfluencers = () =>
  getRequest('/advertiser/profiles/blocked-influencers');
// 博主已拉黑的通告主列表  /influencer/profiles/blocked-advertisers
export const getBlockedAdvertisers = () =>
  getRequest('/influencer/profiles/blocked-advertisers?pageNo=1&pageSize=99');
// 博主取消拉黑通告主 /influencer/profiles/unblock-advertiser
export const unblockAdvertiser = (data: { advertiserUserId: string }) =>
  postRequest('/influencer/profiles/unblock-advertiser', data);

// 获得足迹表(记录博主浏览通告的历史 /influencer/footprints/page
export const getFootprintsPage = () =>
  getRequest('/influencer/footprints/page?pageNo=1&pageSize=99');
// 获取当前用户的邀请码
export const getInviteCode = () => getRequest('/users/invite/code');
// 获取当前通告主的评分统计
export const getRateMyStats = () => getRequest('/advertiser/rating/my-stats');

export const getMessageCount = () =>
  getRequest('/app/message/count', {}, { hideLoading: true });
// 获取我的收藏通告列表
export const getMyFavorites = (data = {}) =>
  getRequest('/advertiser/announcement-details/my-favorites', data);

export const setContactApi = (data) =>
  postRequest('/advertiser/contact/create', data);

// 获取已关注的通告主列表
// /advertiser/profiles/followed GET
export const getFollowedAdvertisers = () =>
  getRequest('/advertiser/profiles/followed?pageNo=1&pageSize=99');
// 退出登录
export const loginOut = (data = {}) =>
  postRequest('/users/logout', data);